import { FC } from 'react';
import { SnackbarProvider } from 'notistack';
import { ApolloProvider } from '@apollo/client';
import { RouterProvider } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

//components
import { ExceptionalContextProvider } from 'contexts/ExceptionalContext';
import { ExceptionalModalConfig } from 'components/common/ExceptionModalUtils';
import { CloseButton, SnackbarUtilsConfiguration } from 'components/common/Alert';

//context, apollo, routes, theme
import client from 'apollo';
import { router } from 'routes';
import customTheme from 'theme';
import { AuthContextProvider } from 'contexts/AuthContext';
import { CheckoutContextProvider } from 'contexts/CheckoutContext';
import { UserSubscriptionsContextProvider } from 'contexts/UserSubscriptions';

const App: FC = () => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY as string}
      scriptProps={{ async: true, defer: true }}>
      <SnackbarProvider
        maxSnack={5}
        autoHideDuration={5000}
        preventDuplicate={true}
        action={(key) => <CloseButton id={key} />}
        classes={{ containerRoot: 'snackbarProvider' }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <SnackbarUtilsConfiguration />
        <ApolloProvider client={client}>
          <AuthContextProvider>
            <UserSubscriptionsContextProvider>
              <CheckoutContextProvider>
                <ThemeProvider theme={customTheme}>
                  <ExceptionalContextProvider>
                    <ExceptionalModalConfig />
                    <CssBaseline />
                    <RouterProvider router={router} />
                  </ExceptionalContextProvider>
                </ThemeProvider>
              </CheckoutContextProvider>
            </UserSubscriptionsContextProvider>
          </AuthContextProvider>
        </ApolloProvider>
      </SnackbarProvider>
    </GoogleReCaptchaProvider>
  );
};
export default App;
